module.exports = __webpack_public_path__ + "img/en-mb-banner.918b5205.png";